<template>
  <div class="bg-white">
    <el-row type="flex" justify="end" class="pt-1">
      <el-col :sm="12">
        <el-form
          class="text-right"
          :inline="true"
          @submit.native.prevent="fetch(1)"
          size="small"
        >
          <el-form-item>
            <!-- <el-input
              v-model="pager.search"
              placeholder="Search..."
              clearable
            ></el-input> -->
            <el-select
              v-model="pager.search"
              placeholder="Search..."
              clearable
              filterable
            >
              <el-option
                v-for="c in glossary"
                :key="c.id"
                :value="c.name"
                :label="c.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetch(1)">Search</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-table
      :data="list.data"
      v-loading="isLoading"
      empty-text="No records found."
    >
      <el-table-column label="Actions" width="100" fixed>
        <template slot-scope="scope">
          <router-link
            class="el-button el-button--primary el-button--small is-circle"
            :to="{ name: 'currency_info', params: { id: scope.row.id } }"
            title="View currency information"
            ><i class="el-icon-folder-opened"></i>
          </router-link>
          <!-- <el-button size="small" type="primary"  icon="el-icon-folder-opened" circle></el-button> -->
          <el-button
            size="small"
            type="danger"
            icon="el-icon-delete"
            @click="itemDelete(scope.row.id)"
            title="Delete currency"
            circle
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column label="Name" prop="name" fixed />
      <el-table-column label="Sign" prop="sign" />
      <el-table-column label="Amount in AED" prop="rate" />
      <el-table-column label="Status" prop="status" />
      <el-table-column label="Date Created" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.created_at | dateFormat }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-show="!isLoading"
      class="pt-1 pb-1"
      background
      layout="prev, pager, next"
      :total="list.paging.total"
      :page-size="pager.limit"
      :current-page="parseInt(list.paging.cur_page)"
      @current-change="fetch"
    ></el-pagination>
  </div>
</template>

<script>
import Currency from "@/models/Currency";
export default {
  name: "CurrencyList",
  computed: {
    list() {
      return this.$store.getters["currency/list"];
    }
  },
  data() {
    return {
      isLoading: false,
      pager: {
        page: 1,
        limit: 25,
        search: ""
      },
      glossary: []
    };
  },
  methods: {
    fetch(page) {
      this.pager.page = page;
      this.isLoading = true;
      var params = { ...this.pager };
      // if (!this.pager.search) delete params.search;
      this.$store.dispatch("currency/getList", params).then(() => {
        this.isLoading = false;
      });
    },
    itemDelete(currency_id) {
      this.$confirm("Are you sure you want to delete this currency?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      })
        .then(() => {
          this.isLoading = true;
          Currency.delete(currency_id).then(resp => {
            this.isLoading = false;
            if (resp.data.msg.code == 200) {
              this.$notify({
                type: "success",
                message: resp.data.msg.msg,
                position: "bottom-right"
              });
              this.fetch(1);
            } else {
              this.$notify({
                type: "danger",
                message: resp.data.msg.msg,
                position: "bottom-right"
              });
            }
          });
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.fetch(1);
    Currency.glossary().then(list => {
      this.glossary = list.data;
    });
  }
};
</script>

<style lang="css" scoped></style>
